import { render } from "./EditLead.vue?vue&type=template&id=2010b65e"
import script from "./EditLead.vue?vue&type=script&lang=js"
export * from "./EditLead.vue?vue&type=script&lang=js"

import exportComponent from "/home/crm/ganarcrm_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__